import NotificationsTypes from "Containers/Notifications/types"

// Notification SSE
export const getNotificationsSSESuccessAction = payload => ({
  type: NotificationsTypes.SSE_NOTIFICATION_SUCCESS,
  payload,
})
export const getNotificationSSEAction = payload => ({
  type: NotificationsTypes.SSE_NOTIFICATION,
  payload,
})


export const postNotificationAction = payload => ({
  type: NotificationsTypes.POST_NOTIFICATION,
  payload,
})
